import React from "react";
import {Box, Button, Container, Paper, TextField, Typography,} from "@mui/material";
import {useForm} from "react-hook-form";
import {useLoginMutation} from '../services/auth'
import Alert from "@mui/material/Alert";
import {useState} from "react";

type LoginFormValues = {
  email: string;
  password: string;
};

export default function LoginPage() {
  const {
    register,
    handleSubmit,
    formState: {errors, isSubmitting},
    reset,
  } = useForm<LoginFormValues>({
    defaultValues: {email: "", password: ""},
    mode: "onBlur", // validate on blur; change to "onSubmit" if you prefer
  });

  const [formError, setFormError] = useState<string | null>(null);
  const [login] = useLoginMutation();

  const onSubmit = async (data: LoginFormValues) => {
    try {
      const result = await login(data).unwrap();
      console.log("✅ Success:", result);
    } catch (err: any) {
      console.log(err);
      setFormError(err.data.message);
      reset({email: data.email, password: ""});

    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{p: 4, mt: 8}}>
        <Typography variant="h4" align="center" gutterBottom>
          Login
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            // react-hook-form
            {...register("email", {
              required: "Email is required",
              pattern: {
                value:
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // simple RFC-like check
                message: "Enter a valid email",
              },
            })}
            error={!!errors.email}
            helperText={errors.email?.message}
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            {...register("password", {
              required: "Password is required",
              minLength: {value: 6, message: "Min length is 6"},
            })}
            error={!!errors.password}
            helperText={errors.password?.message}
          />

          {formError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {formError}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{mt: 2}}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing in..." : "Login"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
